import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./styles/style.css"
import Header from "./components/header/Header";
import AboutUs from "./components/about/About";
import Services from "./components/services/Services";
import Partners from "./components/partners/Partners"
import Footer from "./components/footer/Footer";
import Contacts from "./components/contacts/Contacts";
// import Projects from "./pages/projectPage/project";




function App() {
  return (
      <div className="App">
        
        <Router>     
          <Header/>
          <AboutUs/>
          <Services/>
          <Partners/>
          <Contacts/>
          <Footer/>
        </Router>
        
        
      </div>
  );
}

export default App;